import { Link, useNavigate } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";
import { Waves, LogOut } from "lucide-react";

export default function Navbar({ transparent }) {
  const { user, logout } = useAuth();
  const { site } = useSite();
  const navigate = useNavigate();
  const name = site?.site_name || "LaundryDiary";

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b ${
        transparent ? "border-slate-200/60 bg-white/70 backdrop-blur-xl" : "border-slate-200 bg-white"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          {site?.logo_url ? (
            <img src={site.logo_url} alt={name} className="h-8 w-auto max-w-[140px] object-contain" />
          ) : (
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-white transition-transform group-hover:-translate-y-0.5">
              <Waves className="h-5 w-5" strokeWidth={1.5} />
            </span>
          )}
          {!site?.logo_url && <span className="font-heading text-xl font-bold tracking-tight text-slate-900">{name}</span>}
        </Link>

        <nav className="flex items-center gap-2">
          {!user && (
            <>
              <Link to="/login">
                <Button variant="ghost" className="text-slate-700" data-testid="nav-login">
                  Log in
                </Button>
              </Link>
              <Link to="/register">
                <Button className="rounded-full bg-brand hover:bg-brand-hover" data-testid="nav-register">
                  Start free trial
                </Button>
              </Link>
            </>
          )}
          {user && (
            <>
              <span className="hidden sm:block text-sm text-slate-500">
                {user.name} · <span className="capitalize">{user.role.replace("_", " ")}</span>
              </span>
              <Link to={roleHome(user.role)}>
                <Button variant="secondary" data-testid="nav-dashboard">
                  Dashboard
                </Button>
              </Link>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="nav-logout"
                title="Log out"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
